// Kurum genel bakış ve raporları: B01 (genel bakış, SLA odaklı), B19 (SLA), B21 (raporlar), B22 (CO₂): yönlendirmeler
// (izin + bayrak korumalı, tembel yüklenir).
import { Route } from 'react-router';
import { guard, load } from '../../control/route-utils';

const Overview = load(() => import('./Overview'), 'Overview');
const Sla = load(() => import('./Sla'), 'Sla');
const Reports = load(() => import('./Reports'), 'Reports');
const BusinessReport = load(() => import('./Reports'), 'BusinessReport');
const BusinessCostReport = load(() => import('./Reports'), 'BusinessCostReport');
const Co2 = load(() => import('./Co2'), 'Co2');

export const businessReportsRoutes = (
  <>
    <Route index element={guard(Overview, 'operations')} />
    <Route path="sla" element={guard(Sla, 'reports')} />
    <Route path="raporlar" element={guard(Reports, 'reports')} />
    <Route path="raporlar/co2" element={guard(Co2, 'reports')} />
    <Route path="raporlar/yolcu-basi-maliyet" element={guard(BusinessCostReport, 'reports', { flag: 'FINANCE' })} />
    <Route path="raporlar/:slug" element={guard(BusinessReport, 'reports')} />
  </>
);
